module.exports = __webpack_public_path__ + "img/php.d7f192d5.png";